export const FAKE_NODE_CHILD_PARAM = "__plasmic_fake_child__";
